module.exports = __webpack_public_path__ + "static/GDPR-doruč.to_-996320d4e9a3888f680d85518cdf79a0.pdf";